export default {
  "BASE_URL" : "dev.api.courtmenow.com"
}



// WEBPACK FOOTER //
// ./src/app/env.js